import Input from '../../../../Core/Fields/Floating/Input';
import Date from '../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';

const TotalBox = ({ formData, onFieldChange, extraData }) => {

    return (
           <div className='' style={{ backgroundColor: '#F9F3F5', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px 14px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0 pb-1' style={{fontSize:'16px',fontWeight:'600'}}>Totals</p>
                                        <div className='d-flex justify-content-between pb-1'>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>Grand Total (INR)</p>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#E4AB36'}}>₹00</p>
                                        </div>
                                        <div className='d-flex justify-content-between pb-1'>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>Rounding Adjustment (INR)</p>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>₹00</p>
                                        </div>
                                        <div className='d-flex justify-content-between pb-1'>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>Rounded Total (INR)</p>
                                        <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>₹00</p>
                                        </div>
                                        <div className='d-flex align-item-center' style={{gap:'0px'}}>
                                            <Checkbox id="drt" label="" />
                                            <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>Use Company default Cost Center for Round off</p>
                                        </div>
                                        <div className='d-flex pb-1 align-item-center' style={{gap:'0px'}}>
                                            <Checkbox id="drt" label="" />
                                            <p className='m-0' style={{fontSize:'0.8rem',fontWeight:'500',color:'#2C2B31'}}>Disable Rounded Total</p>
                                        </div>
                                    </div>
                                </div>
                                    
           </div>         
    ); 
};

export default TotalBox;